import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useRiskLevelStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        labelRow: {
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(1),
        },
        labelNumber: {
            width: theme.spacing(2.5),
            // Match the text-field input: 14px, bold, in the primary dark color.
            fontSize: theme.typography.pxToRem(14),
            fontWeight: theme.typography.fontWeightBold,
            color: theme.palette.primary.dark,
            // Nudge down to line up with the text inside the field (which sits lower due to the field's padding).
            marginTop: theme.spacing(1),
        },
        labelIcon: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: theme.spacing(2.5),
            marginTop: theme.spacing(1),
        },
        iconPickerButton: {
            padding: theme.spacing(0.5),
            width: theme.spacing(3.5),
            height: theme.spacing(3.5),
        },
        iconPickerMenuItem: {
            display: "flex",
            justifyContent: "center",
            minHeight: "auto",
            paddingY: theme.spacing(1),
        },
        labelField: {
            flex: 1,
        },
        legend: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: theme.spacing(1, 5),
            marginTop: theme.spacing(1.5),
        },
        legendItem: {
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(0.75),
            fontSize: "0.75rem",
            color: theme.palette.text.secondary,
        },
        legendIcon: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "10px",
        },
    });
};
